module.exports = __webpack_public_path__ + "static/media/flags_USA.6fd2e284.svg";